var map = {
	"./Logo.svg": 41507,
	"./LogoText.svg": 88643,
	"./LogoWhite.svg": 77556,
	"./admin.svg": 3663,
	"./alarm.svg": 83986,
	"./balance.svg": 8801,
	"./cart.svg": 41691,
	"./copy.svg": 64618,
	"./dashboard.svg": 87852,
	"./email.svg": 61162,
	"./exit (2).svg": 5560,
	"./exit.svg": 58745,
	"./exit_account.svg": 96433,
	"./flags/en.svg": 84377,
	"./flags/ru.svg": 57563,
	"./flags/uk.svg": 9093,
	"./green.svg": 25836,
	"./history.svg": 78755,
	"./info.svg": 92775,
	"./label.svg": 21326,
	"./link.svg": 59115,
	"./linkPrev.svg": 94559,
	"./message.svg": 85111,
	"./news.svg": 65519,
	"./pay.svg": 91528,
	"./payment/bsc.svg": 47645,
	"./payment/card.svg": 42533,
	"./payment/cryptocloud.svg": 40563,
	"./payment/enot.svg": 14619,
	"./payment/morune.svg": 95455,
	"./payment/paypal.svg": 32035,
	"./payment/promo.svg": 79357,
	"./payment/qiwi.svg": 9422,
	"./payment/tron.svg": 72292,
	"./platforms/apple.svg": 16006,
	"./platforms/discord.svg": 85410,
	"./platforms/donatello.svg": 66836,
	"./platforms/donatepay.svg": 56438,
	"./platforms/donationalerts.svg": 27655,
	"./platforms/linux.svg": 40207,
	"./platforms/streamelements.svg": 54479,
	"./platforms/streamlabs.svg": 49505,
	"./platforms/telegram.svg": 58054,
	"./platforms/trovo.svg": 7002,
	"./platforms/twitch.svg": 25227,
	"./platforms/windows.svg": 417,
	"./products/application.svg": 41246,
	"./products/application_plus.svg": 97639,
	"./products/application_plus_white.svg": 10884,
	"./products/application_white.svg": 90406,
	"./products/rmavc.svg": 77295,
	"./products/rmavc_white.svg": 47879,
	"./products/streamalerts.svg": 89480,
	"./products/streamalerts_white.svg": 72117,
	"./products/streamalertsds.svg": 133,
	"./products/streamalertsds_white.svg": 27963,
	"./products/streamalertsfull.svg": 46837,
	"./products/streamalertsfull_white.svg": 63475,
	"./referral.svg": 20080,
	"./remove.svg": 97576,
	"./reset.svg": 1127,
	"./ring.svg": 66899,
	"./scroll.svg": 23087,
	"./show.svg": 28537,
	"./status_green.svg": 75218,
	"./status_red.svg": 44993,
	"./tg.svg": 36594,
	"./update.svg": 19061,
	"./user.svg": 30606
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16873;